export type ConversationStarterSection = {
  title: string;
  description?: string;
  questions: string[];
};

export const conversationStartersData: ConversationStarterSection[] = [
  {
    title: "Personal Questions and Life Experiences",
    questions: [
      "What's something you're really passionate about? (hobbies, learning something, work, values, etc.)",
      "When do you feel most at ease talking to another person?",
      "If you could relive one day from your past, which would it be and why?",
      "What is the best vacation you have been on?",
      "What is one (or more) thing that means the most to you?",
      "How come you decided to have a conversation on Knexo?",
    ],
  },
  {
    title: "Questions About Overcoming Social Anxiety",
    questions: [
      "What are your biggest challenges in social situations?",
      "Do you find yourself to be more anxious one on one or in a group?",
      "What have you tried that has helped decrease your social anxiety?",
      "When was a time when you had a successful social interaction and why do you think it was successful?",
      "What would you like to gain from talking to me about overcoming social anxiety?",
      "How do you think we can help each other with our social anxiety today?",
    ],
  },
  {
    title: "Hopes and Dreams",
    questions: [
      "What's a personal goal you're currently working towards?",
      "What's something you've always wanted to try but haven't yet?",
      "If you could have dinner with anyone, dead or alive, who would it be and why?",
      "If money and time weren't an issue, what would you do with your life?",
      "If you could wake up tomorrow having gained any one quality or ability, what would it be?",
      "What is one of your biggest wins / accomplishments in life so far?",
    ],
  },
  {
    title: "Exploring Shared Interests",
    questions: [
      "What's your favorite way to relax after a long day?",
      "What kind of music do you like? Shows? Movies? Activities? Subjects to learn about?",
      "Do you prefer the outdoors or indoors? Why?",
      "What's your favorite place on Earth?",
      "What are activities and things you find particularly meaningful or fun?",
    ],
  },
  {
    title: "To Do List Questions",
    questions: [
      "What would you like to get accomplished today?",
      "What feels like a top priority today?",
      "Is there anything getting in the way of you accomplishing what you would like?",
      "What are signs you might need to take a break?",
      'What can you do to "recharge" your energy if you need to?',
    ],
  },
  {
    title: "First Date / Dating Practice Questions",
    questions: [
      "What's your favorite thing to do in your free time?",
      "What's a book, movie, or show you'd recommend to me?",
      "What's the most adventurous thing you've ever done?",
      "If you could travel anywhere in the world, where would you go?",
      "What's your go-to order at your favorite restaurant?",
      "What do you look for in a person when looking for someone to date? How about someone to be friends with?",
      "What is the most fun date you have been on?",
      "What is the worst date you have been on?",
      "What qualities does your ideal relationship and/or partner have?",
    ],
  },
  {
    title: "Suggest a Game",
    description:
      "Not sure what to talk about? Try playing a quick game together.",
    questions: [
      '20 Questions — One player (the answerer) thinks of a secret person, place, or thing without telling anyone. The other players take turns asking questions one at a time, and the answerer may only reply "Yes" or "No" (or occasionally "Maybe" / "I don\'t know"). The group can ask 20 questions total — a guess also counts as a question — to figure out the secret.',
      'I Spy — One player is the "Spy" and the others are the "Guessers." The Spy gives a clue like "I spy something red," and the Guessers try to figure out the object, asking questions to narrow it down. The first person to guess correctly becomes the next Spy.',
      "Play Trivia — Use a site like Sporcle.com, TriviaCrack.com, or FunTrivia.com. One person asks the other trivia questions, then you switch halfway through the conversation or whenever you choose.",
    ],
  },
  {
    title: "Tips for a Knexo First (and Second, and Twentieth) Timer",
    description:
      'Meeting a stranger and talking to someone new for the first time is going to feel slightly uncomfortable. The goal is to challenge yourself to do something different. "Anything worth doing is worth doing badly."',
    questions: [
      "Find a place where you feel comfortable — a favorite chair, a couch curled up in a blanket, or even a relaxing outdoor space.",
      "Make sure you're not hungry, and bring a refreshing drink to your conversation.",
      "Bring something fun to show your new friend!",
      "Bring a friend with you if you want.",
      "Remember that while challenging yourself and sitting with discomfort is encouraged, it's okay to end a session early if it becomes too much.",
      "Be transparent about your anxiety and comfort level with your conversation partner(s). You can always end the conversation early if you feel overstimulated in some way.",
    ],
  },
  {
    title: "Enter a Calm Headspace",
    questions: [
      "Try a few grounding techniques beforehand — for example, count 5 things that are blue, think of a favorite memory, or name as many capital cities as you can. This helps you focus on something outside your internal experience for a moment.",
      "Visualize what a good conversation might look like, and pair it with a positive belief about yourself. Most people replay what can go wrong, which increases anxiety, and rarely picture what can go well.",
      "Breathe in for 4 seconds and out for 8 seconds, slowly, a few times. This increases activity in your parasympathetic nervous system — the part responsible for relieving stress.",
      "Do a body scan: notice any parts of your body that feel tight or stressed, place your hand there, and feel its warmth and pressure. You can also imagine a calming color of light directed at that area until the tension eases.",
    ],
  },
];
